(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name print.controller:PrintCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('print').controller('PrintGDCtrl', PrintCtrl);

	function PrintCtrl($stateParams, PrintService, StorageServices) {
		var vm = this;
		vm.ctrlName = 'PrintGDCtrl';
		vm.model = {
			blockId : $stateParams.blockId,
			crewScheduleEventId : $stateParams.crewScheduleEventId,
			gdData : null
		};

		function loadGDData() {
			var tabName = 'printGD';
			var printTabData = StorageServices.getTabData(tabName);	
			PrintService.getGDData(printTabData.printGDParams, function(response) {
				vm.model.gdData = response;
			});
		}

		// Init
		(function() {
			if (!!$stateParams.blockId || !!$stateParams.crewScheduleEventId) {
				loadGDData();
			}
		})()

	}
}());
